export const actionModalHeadingStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '32px',
  letterSpacing: '0%',
  margin: 0
}
